import { Fields, VuexState } from '@/common/ClaimsForm';

const state: VuexState = {
	fields: {
		isUserLoggedIn: false,
		brand: '',
		insuredsPolicyInformation: {
			policyNumber: '',
			nameOfInsured: '',
			reportingForAAN: 'Individual',
		},
		involvedInsuredsHealthCareProviders: {
			group: {
				groupName: '',
				buildingOrganization: '',
				streetAddress: '',
				suiteAptUnit: '',
				city: '',
				state: '',
				zipcode: '',
				phonePreference: '',
				phoneNumber: '',
				emailAddress: '',
			},
			providers: [
				{
					firstName: '',
					lastName: '',
					middleInitial: '',
					suffix: '',
					designation: '',
					isThisProviderNamedOnThePolicy: true,
					nationalProviderIdentifier: '',
					buildingOrganization: '',
					streetAddress: '',
					suiteAptUnit: '',
					city: '',
					state: '',
					zipcode: '',
					phonePreference: '',
					phoneNumber: '',
					emailAddress: '',
					sameContactAs: false,
					sameContact: '',
					sameAddressAs: false,
					sameAddress: '',
				},
			],
		},
		primaryContactForThisEventorClaim: {
			relationToInsured: '',
			otherRelationToInsured: '',
			sameAsUser: '',
			firstName: '',
			lastName: '',
			phonePreference: '',
			phoneNumber: '',
			emailAddress: '',
		},
		informationAboutThePatientOrClaimantInvolved: {
			patientType: '',
			other: '',
			firstName: '',
			middleInitial: '',
			lastName: '',
			suffix: '',
			medicareBeneficaryHicNumber: '',

			dateOfBirth: '',
			dateOfDeath: '',
			martialStatus: '',
			noOfDependents: '',
			occupation: '',
			buildingOrganization: '',
			streetAddress: '',
			suiteAptUnit: '',
			city: '',
			state: '',
			zipcode: '',
			phonePreference: undefined,
			phoneNumber: '',
			emailAddress: '',
			residentialAddressSameAsPatient: false,
			contactInformationSameAsPatient: false,
			isThePatientSameAsClaimant: undefined,
			isThePatientClaimantAMedicareBeneficiary: undefined,
			claimant: {
				firstName: '',
				lastName: '',
				relationToSpouse: '',
				streetAddress: '',
				city: '',
				state: '',
				zipcode: '',
				phonePreference: '',
				phoneNumber: '',
				emailAddress: '',
			},
		},
		informationAboutTheClaimIncident: {
			dateOfIncident: '',
			dateNotifiedOfIncident: '',
			lossLocationName: '',
			sameAddressAs: false,
			sameAddress: '',
			buildingOrganization: '',
			streetAddress: '',
			suiteAptUnit: '',
			city: '',
			state: '',
			zipcode: '',
			reportType: '',
			reportTypeOther: '',
			dateServed: '',
			actionRequest: '',
			descriptionOfIncident: '',

			anyOtherApplicableInsuranceCoverage: '',
		},
		supportDocuments: {
			files: [],
			fileLog: [],
			uploads: [],
		},
		claimantPlantiffAttorneyInformation: {
			firstName: '',
			lastName: '',
			middleInitial: '',
			suffix: '',
			designation: '',
			lawFirmName: '',
			buildingOrganization: '',
			streetAddress: '',
			suiteAptUnit: '',
			city: '',
			state: '',
			zipcode: '',
			phonePreference: '',
			phoneNumber: '',
			emailAddress: '',
		},
		noticiesSignaturesSubmissionOfReport: {
			readAndAcceptNoticies: false,
			nameOfPersonSubmittingReport: '',
			relationToInsured: '',
			authorizedToSubmt: false,
			otherRelationToInsured: '',
			guiltyOfCrime: false,
		},
	},
	emptyProvider: {
		firstName: '',
		lastName: '',
		middleInitial: '',
		suffix: '',
		designation: '',
		isThisProviderNamedOnThePolicy: '',
		nationalProviderIdentifier: '',
		buildingOrganization: '',
		streetAddress: '',
		suiteAptUnit: '',
		city: '',
		state: '',
		zipcode: '',
		phonePreference: '',
		phoneNumber: '',
		emailAddress: '',
		sameAddress: '',
		sameAddressAs: false,
		sameContact: '',
		sameContactAs: false,
	},
};

const getters = {};

const mutations = {
	updateInsuredsPolicyInformation(state: VuexState, payload: Fields) {
		state.fields = payload;
	},
};

const actions = {};

export { state, getters, mutations, actions };
